"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateApp = void 0;

var _validateProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty");

var validateApp = function validateApp(app) {
  var isValidApp = typeof app === 'string' && app.length > 0;
  return (0, _validateProperty.validateProperty)(isValidApp, "expected app to be a non-empty string but got " + app, 'app');
};

exports.validateApp = validateApp;